<div class="azay-footer text-center">
  <img class="mt-3 mb-3" src="assets/images/azay-logo.png" />
  <div [innerHTML]="'otp.footer' | translate"></div>
</div>
